/* eslint-disable prefer-template, arrow-body-style */
import * as Config from 'es6/components/memory-bank/config';
import { t } from 'es6/services/localization';
import { relativeTime } from 'es6/helpers/time';

/**
 * Tooltip methods for the MemoryBank. Uses the tipped library.
 *
 * @requires moment
 * @requires JST
 * @requires Tipped
 */
export class Tooltip {
  /**
   * @this HTMLElement  <g> tag for the node
   * @param {MemoryBankNode} node
   */
  static create(node) {
    let shortTermMemory = '';
    let studyDateRelative;

    if (node.isNew()) {
      studyDateRelative = t('study-new');
    } else {
      studyDateRelative = relativeTime(node.seeNextAt);
    }

    if (node.isReady() && node.shortTermMemory) {
      shortTermMemory = t('memory-bank.see-next-short-term-memory');
    }

    const content = JST['memory_bank/tooltips/progress/item']({
      id:                   node.id,
      cue:                  node.name,
      debug:                debugInformation(node),
      isComplete:           node.isComplete(),
      isNew:                node.isNew,
      progress:             Math.floor(node.progress),
      progressDifference:   Math.floor(node.getProgressDifference()),
      shortTermMemory,
      studyDate:            node.seeNextAt,
      studyDateRelative,
      studyTimeTranslation: t('from-now'),
    });

    Tipped.create(this, content, Config.Tooltip).show();
  }

  /**
   * @this HTMLElement  <g> tag for the node
   * @param {MemoryBankNode} node
   */
  static remove(node) {
    Tipped.remove(this);
  }
}

/**
 * Includes debug information in the underscore template.
 */
function debugInformation(node) {
  if (Smartfm && Smartfm.Apps && Smartfm.Apps.Settings.StealthMode) {
    const debugVars = {
      id:                 node.id,
      current_retention:  node.currentRetention,
      difficulty_bucket:  node.difficultyBucket,
      easiness_modifier:  node.easinessModifier,
      inSession:          node.inSession,
      interval_hours:     (node.reviewInterval / 3600000).toFixed(2) + ' hours',
      last_study_time:    node.lastStudyTime.toISOString(),
      progress:           node.progress,
      see_next_at:        node.seeNextAt.toISOString(),
      review_interval:    node.reviewInterval,
      previous_retention: node.previous ? node.previous.currentRetention : 'n/a',
      previous_interval:  node.previous ? node.previous.reviewInterval : 'n/a',
    };

    const debugItems = Object.keys(debugVars).map(key => {
      return DEBUG_ITEM_TEMPLATE({ key, value: debugVars[key] });
    }).join(' ');

    return DEBUG_TEMPLATE({ debugItems });
  }

  return '';
}

const DEBUG_TEMPLATE = _.template(
  '<div class="debug">{{= debugItems }}</div>'
);

const DEBUG_ITEM_TEMPLATE = _.template(
  '<div class="debug-item">' +
  ' <div class="key">{{= key }}: </div>' +
  ' <div class="value">{{= value }}</div>' +
  '</div>'
);

export default Tooltip;
